// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchBar {
    width: 100%;
    margin: 0 auto;
    background-color: #F5F5F5;
    padding: 16px 0;
    text-align: left;
    font-size: 14px;

}

#search_switch {
    margin-left: 16px;
    padding: 8px 24px;
    font-size: 13px;
}

.search_dealer, .search_admin, .search_agency, .search_financial {
    width: calc(100% - 32px);
    display: flex;
    margin: 0;
    padding: 0 16px;
    justify-content: space-between;
    align-items: center;
    max-height: 0;
    overflow: hidden;
    transition: max-height .5s ease-in-out;
}

.search_admin.open, .search_dealer.open, .search_financial.open, .search_agency.open{
    max-height: 1000px;
    transition: max-height .6s ease-in-out;
}

.search_input {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    row-gap: 16px;
    justify-items: stretch;
    margin-top: 16px;
}

.search_input label {
    font-size: 14px;
    width: 40%;
    max-width: 80px;
    text-align: right;
    margin-right: 16px;
}

.search_input input {
    width: 50%;
    padding: 5px 10px;
    font-size: 14px;
}

.search_input select {
    width: 60%;
    padding: 5px 8px;
    height: 28px;
}

.search_input > div {
    display: flex;
    align-items: center;
}

.search_agency .search_input {
    grid-template-columns: auto auto auto auto;
}

.search_values {
    border: 1px solid #cccccc;
}

#search_registration_date {
    display: flex;
    align-items: center;
}

#search_registration_date input {
    width: 60%;
    margin: 0;
    padding: 6px 20px 6px 8px;
    font-size: 12px;
}

#searchBtn {
    width: 8%;
    max-width: 80px;
    height: 48px;
    background: linear-gradient(to bottom, #5a5a5a 0, #000000 100%);
    font-size: 15px;
}

#searchBtn:hover {
    background: linear-gradient(to bottom, #5a5a5a 0, #000000 70%);
    transition: width 1s ease;
}

@media screen and (max-width: 1000px) {
    .searchBar {
        margin: 0;
    }

    .search_dealer, .search_admin, .search_agency, .search_financial {
        height: 100%;
        flex-direction: column;
        align-items: start;
        margin-bottom: 0;
    }

    .search_dealer label, .search_admin label, .search_agency label, .search_financial label {
        text-align: left;
    }

    .search_input {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 30px;
    }
    .search_input > div{
        width: 100%;
    }

    .search_input input{
        width: 45%;
        max-width: 150px;
    }
    .search_input select{
        width: 55%;
        max-width: 170px;
    }
    #search_registration_date input {
        width: 100%;
        margin: 0;
        padding: 6px 0;
        text-align: center;
    }
    #searchBtn{
        width: 25%;
        height: 35px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/SearchBar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,SAAS;IACT,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,YAAY;IACZ,+DAA+D;IAC/D,eAAe;AACnB;;AAEA;IACI,8DAA8D;IAC9D,yBAAyB;AAC7B;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,SAAS;QACT,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,YAAY;IAChB;AACJ","sourcesContent":[".searchBar {\n    width: 100%;\n    margin: 0 auto;\n    background-color: #F5F5F5;\n    padding: 16px 0;\n    text-align: left;\n    font-size: 14px;\n\n}\n\n#search_switch {\n    margin-left: 16px;\n    padding: 8px 24px;\n    font-size: 13px;\n}\n\n.search_dealer, .search_admin, .search_agency, .search_financial {\n    width: calc(100% - 32px);\n    display: flex;\n    margin: 0;\n    padding: 0 16px;\n    justify-content: space-between;\n    align-items: center;\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height .5s ease-in-out;\n}\n\n.search_admin.open, .search_dealer.open, .search_financial.open, .search_agency.open{\n    max-height: 1000px;\n    transition: max-height .6s ease-in-out;\n}\n\n.search_input {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    align-items: center;\n    row-gap: 16px;\n    justify-items: stretch;\n    margin-top: 16px;\n}\n\n.search_input label {\n    font-size: 14px;\n    width: 40%;\n    max-width: 80px;\n    text-align: right;\n    margin-right: 16px;\n}\n\n.search_input input {\n    width: 50%;\n    padding: 5px 10px;\n    font-size: 14px;\n}\n\n.search_input select {\n    width: 60%;\n    padding: 5px 8px;\n    height: 28px;\n}\n\n.search_input > div {\n    display: flex;\n    align-items: center;\n}\n\n.search_agency .search_input {\n    grid-template-columns: auto auto auto auto;\n}\n\n.search_values {\n    border: 1px solid #cccccc;\n}\n\n#search_registration_date {\n    display: flex;\n    align-items: center;\n}\n\n#search_registration_date input {\n    width: 60%;\n    margin: 0;\n    padding: 6px 20px 6px 8px;\n    font-size: 12px;\n}\n\n#searchBtn {\n    width: 8%;\n    max-width: 80px;\n    height: 48px;\n    background: linear-gradient(to bottom, #5a5a5a 0, #000000 100%);\n    font-size: 15px;\n}\n\n#searchBtn:hover {\n    background: linear-gradient(to bottom, #5a5a5a 0, #000000 70%);\n    transition: width 1s ease;\n}\n\n@media screen and (max-width: 1000px) {\n    .searchBar {\n        margin: 0;\n    }\n\n    .search_dealer, .search_admin, .search_agency, .search_financial {\n        height: 100%;\n        flex-direction: column;\n        align-items: start;\n        margin-bottom: 0;\n    }\n\n    .search_dealer label, .search_admin label, .search_agency label, .search_financial label {\n        text-align: left;\n    }\n\n    .search_input {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: space-between;\n        margin-bottom: 30px;\n    }\n    .search_input > div{\n        width: 100%;\n    }\n\n    .search_input input{\n        width: 45%;\n        max-width: 150px;\n    }\n    .search_input select{\n        width: 55%;\n        max-width: 170px;\n    }\n    #search_registration_date input {\n        width: 100%;\n        margin: 0;\n        padding: 6px 0;\n        text-align: center;\n    }\n    #searchBtn{\n        width: 25%;\n        height: 35px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
